import * as modalSelectors from './modalSelectors';
import * as modalActions from './modalActions';
import * as modalTypes from './modalTypes';
import reducer from './modalReducer';

export { modalSelectors, modalActions, modalTypes };
export default reducer;
